import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../foundation/apiClient';
import {APIResponse, OrderStatusUpdateRequestDTO} from './models';

export const getOrderDetails = async (orderId: string): Promise<APIResponse> => {
    const response = await apiClient.get(`order/details/get?orderId=${orderId}`);
    return response.data;
};

export const getOrderInfoDetails = async (): Promise<APIResponse> => {
    const response = await apiClient.get('orders/dashboard/get/orderInfoList');
    return response.data;
};

export const updateOrderStatus = async (
    orderStatusUpdateRequestDTO: OrderStatusUpdateRequestDTO,
): Promise<OrderStatusUpdateRequestDTO> => {
    const response = await apiClient.post('orders/dashboard/update', orderStatusUpdateRequestDTO);
    return response.data;
};

export const useOrderInfoDetails = () => {
    return useQuery({
        queryKey: ['order-info-list'],
        queryFn: () => getOrderInfoDetails(),
        staleTime: 1200,
    });
};

export const useOrderDetails = (orderId: string | null) => {
    return useQuery({
        queryKey: ['order-details', orderId],
        queryFn: () => {
            if (orderId) {
                return getOrderDetails(orderId);
            } else {
                return null;
            }
        },
        staleTime: 10000,
    });
};
